import Menu from 'antd/es/menu';
import MenuProps from 'antd/es/menu';

export default Menu;
export { MenuProps };
